import { Button, Icons, useToggle } from '@commenda/kakashi';
import {
  TaskParty,
  TaskStatus,
} from '@prisma/client';
import { ServiceRequestTaskLabel } from '../../../common/labels';
import { ServiceRequestTaskIconConfig } from '../../../common/taskIconConfig';
import { ServiceRequestTaskCard } from '../../../layout/components/taskCard/ServiceRequestTaskCard';
import { ServiceRequestTaskCardConfig, TCommonTaskProp } from '../../../types';
import { updateTaskStatus } from '../../../utils';
import { ShareHoldingInstructionsModal } from './modal/ShareHoldingInstructionsModal';

export const ShareHoldingInstructions = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { role, mutate } = context;

  const shareHoldingInstructionsModalVisibility = useToggle();

  const config: ServiceRequestTaskCardConfig = {
    getLeftIcon: (status) => ServiceRequestTaskIconConfig[status],
    getStateConfig: (state) => {
      const stateMap = {
        [TaskParty.CLIENT]: {
          [TaskStatus.COMPLETED]: {
            actions: (
              <Button
                size="sm"
                variant="secondary"
                onClick={shareHoldingInstructionsModalVisibility.toggle}
              >
                View instructions
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel
                label="Instructions for share purchase agreement reviewed"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
          [TaskStatus.TO_DO]: {
            actions: (
              <Button
                size="sm"
                onClick={shareHoldingInstructionsModalVisibility.toggle}
              >
                Start
                <Icons.ArrowNarrowRight className="size-4" />
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Review instructions for share purchase agreement" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: (
              <Button size="sm" disabled onClick={() => {}} variant="primary">
                Start
                <Icons.ArrowNarrowRight className="size-4" />
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel label="Review instructions for share purchase agreement" />
            ),
          },
        },
        [TaskParty.AGENT]: {
          [TaskStatus.COMPLETED]: {
            actions: (
              <Button
                size="sm"
                variant="secondary"
                onClick={shareHoldingInstructionsModalVisibility.toggle}
              >
                View instructions
              </Button>
            ),
            label: (
              <ServiceRequestTaskLabel
                label="Instructions for share purchase agreement reviewed by client"
                status={task.status}
                timestamp={task.updatedAt}
              />
            ),
          },
          [TaskStatus.TO_DO]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Client reviews instructions for share purchase agreement" />
            ),
          },
          [TaskStatus.BACKLOG]: {
            actions: null,
            label: (
              <ServiceRequestTaskLabel label="Client reviews instructions for share purchase agreement" />
            ),
          },
        },
      };

      return (
        stateMap[state.role]?.[state.status] ?? {
          label: task.title,
          actions: null,
        }
      );
    },
  };

  return (
    <div>
      <ServiceRequestTaskCard
        task={task}
        state={{ role, status: task.status }}
        config={config}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
      <ShareHoldingInstructionsModal
        isOpen={shareHoldingInstructionsModalVisibility.visible}
        onClose={shareHoldingInstructionsModalVisibility.hide}
        taskStatus={task.status}
        onSubmit={async () => {
          updateTaskStatus({
            task,
            status: TaskStatus.COMPLETED,
            mutate,
          });
          shareHoldingInstructionsModalVisibility.toggle();
        }}
      />
    </div>
  );
};
